__turbopack_context__.v({
  "details": "CurrentDayForecast-module-scss-module__svUtGG__details",
  "icon": "CurrentDayForecast-module-scss-module__svUtGG__icon",
  "section": "CurrentDayForecast-module-scss-module__svUtGG__section",
  "temperature": "CurrentDayForecast-module-scss-module__svUtGG__temperature",
});
